import React from "react";

interface TextAlignIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const TextAlignIcon = ({
    className = "",
    color = "currentColor",
    size = "lg",
}: TextAlignIconProps) => {
    const sizeClasses = {
        sm: "w-5 h-5",   // ~20x20x
        md: "w-6 h-6",   // ~24x24px
        lg: "w-8 h-8",   // ~32x32px
        xl: "w-10 h-10", // ~40x40px
    };

    return (
        <div className="icon text-align-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M3 5h18" />
                <path d="M3 12h18" />
                <path d="M3 19h9" />
            </svg>
        </div>
    );
};

export default TextAlignIcon;

